﻿'use strict';

angular.module('ntmApp').factory('DragFromRPToOtherActivities', ['DraggingObject', 'DailyPlanService', 'FlashService', 'DailyPlanConfirmationService', 'WatchDndTargetsService', 'ActivitiesGroupSkillsValidator', 'ActivitySkillsValidator',
    function (DraggingObject, DailyPlanService, FlashService, DailyPlanConfirmationService, WatchDndTargetsService, ActivitiesGroupSkillsValidator, ActivitySkillsValidator) {

        function DragFromRPToOtherActivities(view) {

            var self = this;

            var onStartDraggingEvent = null;
            var onEndDraggingEvent = null;

            self.startDragging = function (staff) {

                if (onStartDraggingEvent) {
                    var allowed = onStartDraggingEvent(staff);

                    if (allowed) {
                        self.DraggingObject.setDraggingObject(staff);
                    }
                }
            };

            self.drag = function (staff) {

                var draggingInfo = view.getInfoForDraggingAction();

                draggingInfo.personId = staff.personId;
                draggingInfo.personName = staff.staffName;
                draggingInfo.availableTime = staff.available;
                draggingInfo.allTargetStaffSkill = staff.allTargetStaffSkill;

                if (draggingInfo.isSingleActivity) {

                    var startExcecuteDraggingToRow = function () {
                            proccessDragAndDropEventFromResourcePoolToGridRow(draggingInfo);
                    };

                    dndRowPreSaveCheck(draggingInfo, startExcecuteDraggingToRow);
                } else if (draggingInfo.isActivitiesGroup) {

                    if (draggingInfo.scheduleIds.length > 0) {

                        var startExcecuteDraggingToGroup = function () {
                                proccessDragAndDropEventFromResourcePoolToGrid(draggingInfo);
                           
                        };

                        dndPreSaveCheck(draggingInfo, startExcecuteDraggingToGroup);
                    } else {
                        FlashService.Error('No un-assigned activities. If you wish to replace existing assignments, please check the Replace Existing Assignments checkbox in the Resource Pool.', true);
                        view.defaultDndTargets();
                    }
                } else if (draggingInfo.isLocationActivities) {

                    if (draggingInfo.scheduleIds.length > 0) {

                        var startExcecuteDraggingToLocation = function () {
                                proccessDragAndDropEventFromResourcePoolToGrid(draggingInfo); 
                        };

                        dndPreSaveCheck(draggingInfo, startExcecuteDraggingToLocation);
                    } else {
                        FlashService.Error('No un-assigned activities. If you wish to replace existing assignments, please check the Replace Existing Assignments checkbox in the Resource Pool.', true);
                        view.defaultDndTargets();
                    }
                }
            };

            self.endDragging = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.DraggingObject.releaseDraggingObject();
                }
            };

            self.onStartDragging = function (event) {
                onStartDraggingEvent = event;
                return self;
            };

            self.onEndDragging = function (event) {
                onEndDraggingEvent = event;
                return self;
            };

            function dndPreSaveCheck(draggingInfo, functionToExcecute) {
                var activitiesTotalDuration = (draggingInfo.schedules.sumOf('totalDuration') / 60).toFixed(2);
                var sourceAndTargetDifference = activitiesTotalDuration - draggingInfo.availableTime;
                var messageStringUnassignedActivitiesDiff = draggingInfo.isLocationActivities ? 'these' : 'this set of';
                var messageStringActivitiesDiff = draggingInfo.isLocationActivities ? 'all of these' : 'this set of';

                var assigneeHoursCheck = function () {
                    if (draggingInfo.availableTime < activitiesTotalDuration) {

                        if (!draggingInfo.isExistingAssignments) {
                            DailyPlanConfirmationService.MoveFromResourcePool('Assigning ' + draggingInfo.personName +
                                ' to ' + messageStringUnassignedActivitiesDiff + ' un-assigned activities will over-allocate them by ' +
                                sourceAndTargetDifference.toFixed(2) + 'hrs.')
                                                   .Yes(functionToExcecute)
                                                   .No(function () {
                                                    view.defaultDndTargets();
                                                   })
                                                   .Ask();
                        } else {
                            DailyPlanConfirmationService.MoveFromResourcePool('Assigning ' + draggingInfo.personName +
                                ' to ' + messageStringActivitiesDiff + ' activities will over-allocate them by ' +
                                sourceAndTargetDifference.toFixed(2) + 'hrs.')
                                                   .Yes(functionToExcecute)
                                                   .No(function () {
                                                    view.defaultDndTargets();
                                                   })
                                                   .Ask();
                        }
                    } else {
                        functionToExcecute();
                    }
                };

                if ((draggingInfo.isExistingAssignments) && (draggingInfo.targetActivitiesInNewStatusList.length !== draggingInfo.schedules.length)) {
                    draggingInfo.schedules = draggingInfo.targetActivitiesInNewStatusList;
                    draggingInfo.scheduleIds = [];
                    draggingInfo.schedules.forEach(function (schedule) { draggingInfo.scheduleIds.push(schedule.scheduleId); });
                    activitiesTotalDuration = (draggingInfo.schedules.sumOf('totalDuration') / 60).toFixed(2);
                    sourceAndTargetDifference = activitiesTotalDuration - draggingInfo.availableTime;

                    DailyPlanConfirmationService.MoveFromResourcePool('Some activities have already been started and/or completed by the currently assigned staff. Only the activities that are not started will be reassigned.')
                                               .Yes(assigneeHoursCheck)
                                               .No(function () {
                                                view.defaultDndTargets();
                                               })
                                               .Ask();
                } else if ((draggingInfo.isExistingAssignments) && (draggingInfo.targetActivitiesInNewStatusList.length === 0)) {
                    FlashService.Error('The currently assigned staff have already started or completed every activity in this group. Nothing can be reassigned.', true);
                    view.defaultDndTargets();
                } else {
                    assigneeHoursCheck();
                }
            }

            function dndRowPreSaveCheck(draggingInfo, functionToExcecute) {
                var activitiesTotalDuration = (draggingInfo.schedule.totalDuration / 60).toFixed(2);
                var sourceAndTargetDifference = activitiesTotalDuration - draggingInfo.availableTime;

                if (draggingInfo.availableTime < activitiesTotalDuration) {
                    DailyPlanConfirmationService.MoveFromResourcePool('Assigning ' + draggingInfo.personName +
                        ' to this activity will over-allocate it by ' +
                        sourceAndTargetDifference.toFixed(2) + 'hrs.')
                                           .Yes(functionToExcecute)
                                           .No(function () {
                                              view.defaultDndTargets();
                                           })
                                           .Ask();
                } else {
                    functionToExcecute();
                }
            }

            function proccessDragAndDropEventFromResourcePoolToGrid(dragInformation) {

                if(!dragInformation.isStaffSkillsCheck){

                    var skillsValidator = new ActivitiesGroupSkillsValidator(dragInformation.activities, {}, { personId: dragInformation.personId, staffName: dragInformation.personName }, dragInformation.allTargetStaffSkill, dragInformation.isExistingAssignments);

                    if (skillsValidator.isValid()) {
                        dragInformation.isStaffSkillsCheck = true;
                    } else {
                        var moveFromResourcePool = function () { dragInformation.isStaffSkillsCheck = true; proccessDragAndDropEventFromResourcePoolToGrid(dragInformation); };

                      var  popupMessage = dragInformation.personName + ' is not qualified for the following ' +
                                        (dragInformation.isExistingAssignments ? '' : 'un-assigned ') +
                                        'activities' + (dragInformation.isLocationActivities ? '' : 'in this set') + ': ';


                        DailyPlanConfirmationService.MoveFromResourcePool(popupMessage, skillsValidator.getNonValidActivitiesArray().sort())
                                         .Yes(moveFromResourcePool)
                                         .No(function () {
                                            view.defaultDndTargets();
                                         })
                                         .Ask();
                    }

                }
              
                if(dragInformation.isStaffSkillsCheck)
                {
                    var request = {
                        personId: dragInformation.personId,
                        personName: dragInformation.personName,
                        date: dragInformation.date,
                        scheduleIds: dragInformation.scheduleIds,
                        scopeCode: dragInformation.scopeCode,
                        otherActivityMode: dragInformation.otherActivityMode,
                        isExistingAssignments: dragInformation.isExistingAssignments
                    };

                        var loadingModal = FlashService.Loading();

                        if (dragInformation.isActivitiesGroup) {
                            DailyPlanService.DragFromResourcePoolToOtherActivitiesGridGroup(request).then(function (result) {
                                loadingModal.dismiss();
                                FlashService.Success(result.data.message);
                            });
                        } else if (dragInformation.isLocationActivities) {
                            DailyPlanService.DragFromResourcePoolToOtherActivitiesLocation(request).then(function (result) {
                                loadingModal.dismiss();
                                FlashService.Success(result.data.message);
                            });
                        }
                    }


                
            }
                    
                
            

            function proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation) {


                            if(!dragInformation.isStaffSkillsCheck)
                                {

                                var skillsValidator = new ActivitySkillsValidator({ speciesId: dragInformation.speciesId, speciesName: dragInformation.speciesName, activityId: dragInformation.activityId, activity: dragInformation.activity }, {}, { personId: dragInformation.personId, staffName: dragInformation.personName }, dragInformation.allTargetStaffSkill);

                                if (skillsValidator.isValid()) {
                                    dragInformation.isStaffSkillsCheck = true;
                                } else {
                                    var moveFromResourcePool = function () { dragInformation.isStaffSkillsCheck = true; proccessDragAndDropEventFromResourcePoolToGridRow(dragInformation); };

                                    DailyPlanConfirmationService.MoveStaffFromResourcePoolToRoomActivityRow("{0} is not qualified for this activity.".format(dragInformation.personName))
                                                               .Yes(moveFromResourcePool)
                                                               .No(function () {
                                                                   view.defaultDndTargets();
                                                               })
                                                               .Ask();
                                }

                            } 

                            if (dragInformation.isStaffSkillsCheck) {

                                var loadingModal = FlashService.Loading();

                                var request = {
                                    facilityCode: dragInformation.facilityCode,
                                    roomNumber: dragInformation.roomNumber,
                                    date: dragInformation.date,
                                    scheduleId: dragInformation.scheduleId,
                                    personId: dragInformation.personId,
                                    personName: dragInformation.personName,
                                    activityName: dragInformation.activityName
                                };

                                DailyPlanService.DragFromResourcePoolToOtherActivitiesGridRow(request).then(function (result) {
                                    loadingModal.dismiss();

                                    if (result.data) {
                                        FlashService.Success(result.data.message);
                                    }
                                });



                            }
             
            }

            function initialize() {
                self.DraggingObject = new DraggingObject();
                self.DraggingType = "DRAG_FROM_RESOURCE_POOL";
            }

            initialize();

        }

        return (DragFromRPToOtherActivities);

    }]);